/* ------------------------------------------------------------------
   Made Good — Set Aside v1
   Written 1 Sep 2026 · wishlist workstream · see mg-setaside-build-spec-v1

   The ONE rule: nothing else in the theme touches localStorage. Every
   read and write goes through MG.setAside. That is what makes the v2
   server swap a change to this file instead of a migration.

   Buttons are rendered by Liquid (snippets/mg-setaside-button.liquid).
   This file never inserts a node, never measures a card, and never asks
   the browser a layout question — it toggles one class. That is the
   whole difference from the app it replaces.
------------------------------------------------------------------ */
(function () {
  'use strict';

  var KEY = 'mg_setaside_v1';
  var VERSION = 1;
  var SELECTOR = '[data-mg-setaside]';
  var SAVED = 'is-saved';

  var cache = null;
  var subs = [];

  function blank() { return { v: VERSION, updatedAt: 0, items: [] }; }

  function read() {
    if (cache) { return cache; }
    var raw;
    try { raw = window.localStorage.getItem(KEY); }
    catch (e) { cache = blank(); return cache; }
    if (!raw) { cache = blank(); return cache; }
    var data;
    try { data = JSON.parse(raw); } catch (e) { data = null; }
    if (!data || data.v !== VERSION || !Array.isArray(data.items)) { data = blank(); }
    cache = data;
    return cache;
  }

  function commit(data) {
    data.v = VERSION;
    data.updatedAt = Date.now();
    cache = data;
    try { window.localStorage.setItem(KEY, JSON.stringify(data)); } catch (e) {}
    announce();
  }

  function announce() {
    var items = read().items;
    for (var i = 0; i < subs.length; i++) {
      try { subs[i](items); } catch (e) {}
    }
  }

  function indexOfProduct(items, productId) {
    for (var i = 0; i < items.length; i++) {
      if (items[i].productId === productId) { return i; }
    }
    return -1;
  }

  var setAside = {

    get: function () { return read().items.slice(); },

    count: function () { return read().items.length; },

    /* Product-level. One entry per product, never two sizes of the same thing. */
    has: function (productId) { return indexOfProduct(read().items, productId) !== -1; },

    find: function (productId) {
      var items = read().items;
      var i = indexOfProduct(items, productId);
      return i === -1 ? null : items[i];
    },

    /* record: { productId, variantId, handle, price, currency }
       variantId is the size chosen at save time, remembered so the Set Aside
       page can pre-select it. It is NOT part of identity — saving the same
       product again replaces the entry and the newer size wins. */
    add: function (record) {
      var data = read();
      var items = data.items.filter(function (item) {
        return item.productId !== record.productId;
      });
      items.unshift({
        productId: record.productId,
        variantId: record.variantId || 0,
        handle: record.handle || '',
        price: record.price || 0,
        currency: record.currency || 'NZD',
        savedAt: Date.now()
      });
      data.items = items;
      commit(data);
      return setAside.get();
    },

    remove: function (productId) {
      var data = read();
      data.items = data.items.filter(function (item) {
        return item.productId !== productId;
      });
      commit(data);
      return setAside.get();
    },

    /* Fires on every change, including one made in another tab. */
    subscribe: function (fn) {
      if (typeof fn !== 'function') { return function () {}; }
      subs.push(fn);
      return function () {
        var i = subs.indexOf(fn);
        if (i !== -1) { subs.splice(i, 1); }
      };
    }
  };

  window.MG = window.MG || {};
  window.MG.setAside = setAside;

  /* ---------------- UI ---------------- */

  function paint() {
    var items = read().items;
    var ids = {};
    for (var i = 0; i < items.length; i++) { ids[items[i].productId] = true; }

    var buttons = document.querySelectorAll(SELECTOR);
    for (var b = 0; b < buttons.length; b++) {
      var el = buttons[b];
      var on = ids[parseInt(el.getAttribute('data-product-id'), 10)] === true;
      el.classList.toggle(SAVED, on);
      el.setAttribute('aria-pressed', on ? 'true' : 'false');
    }

    /* P1, 1 Sep. Empty rather than "0" — mg-setaside.css hides an :empty
       counter and its brackets, so an empty list shows no stray "[0]". */
    var counters = document.querySelectorAll('[data-mg-setaside-count]');
    for (var c = 0; c < counters.length; c++) {
      counters[c].textContent = items.length ? String(items.length) : '';
    }

    /* The header link is rendered with the `hidden` attribute and revealed
       here once there is something to see. That is hideWhenZero, which is
       what the app does today — measured on V16, 1 Sep: the whole control
       is display:none at a count of zero, not just the number. Keeping the
       same behaviour means the header looks unchanged on publish day.
       ⚠️ 5 Sep: this SETS hidden, it does not merely clear it, so any element
       carrying data-mg-setaside-link vanishes at zero. That is why the mobile
       menu row (snippets/mg-setaside-menu-link.liquid) deliberately carries
       data-mg-setaside-COUNT and NOT -LINK — it must never hide, being the only
       route to this page on a phone. Do not "tidy" the attribute in. */
    var links = document.querySelectorAll('[data-mg-setaside-link]');
    for (var k = 0; k < links.length; k++) {
      links[k].hidden = items.length === 0;
    }

    /* P2. The Set Aside page's title count, written the same way the collection
       page writes its own: <h1>All Goods <sup>514</sup></h1>. Empty rather than
       "0" so an :empty sup collapses and the heading reads plainly. */
    var sups = document.querySelectorAll('[data-mg-setaside-count-sup]');
    for (var q = 0; q < sups.length; q++) {
      sups[q].textContent = items.length ? String(items.length) : '';
    }
  }

  /* ⚠️⚠️ C70, 5 Sep. THE VARIANT MUST BE READ AT CLICK TIME, NOT FROM THE
     ATTRIBUTE. `data-variant-id` is written by Liquid at page load and is never
     refreshed, because the theme changes variant client-side. So a customer who
     switched XS → L and saved got XS: measured on culottes-dahlia, the select
     and the URL both moved to 51541993554226 while the attribute stayed
     51541993455922. That put the wrong size on the Set Aside card, and "Add all
     items to cart" would then have ordered it.
     ⭐ The scope is deliberately NARROW — the card's own form, or the product
     form on a PDP. NEVER document-wide: the Set Aside page has one form per
     card, and a document-wide lookup would give every card the first card's size.
     Returns 0 where there is no selector (collection grids), so the attribute
     stays the source of truth there, which is correct for a single-variant tile. */
  function liveVariantId(el) {
    if (!el || !el.closest) { return 0; }
    var scope = el.closest('[data-mg-setaside-card]') ||
                el.closest('form') ||
                el.closest('.product_form');
    if (!scope) { return 0; }
    var sel = scope.querySelector('select.variant-selection__variants, select[name="id"]');
    if (!sel) { return 0; }
    var v = parseInt(sel.value, 10);
    return v > 0 ? v : 0;
  }

  function recordFrom(el) {
    return {
      productId: parseInt(el.getAttribute('data-product-id'), 10),
      variantId: liveVariantId(el) || parseInt(el.getAttribute('data-variant-id'), 10) || 0,
      handle: el.getAttribute('data-handle') || '',
      price: parseInt(el.getAttribute('data-price'), 10) || 0,
      currency: el.getAttribute('data-currency') || 'NZD'
    };
  }

  /* Klaviyo fires on add only, never on remove, and only if it is present.
     Metric name must match exactly — the live reminder flow is bound to it. */
  function tellKlaviyo(record) {
    if (!window.klaviyo || typeof window.klaviyo.track !== 'function') { return; }
    var items = read().items.slice(0, 10);
    var latest = items.map(function (item) {
      return { ProductId: item.productId, VariantId: item.variantId, ItemId: item.productId };
    });
    var flat = read().items.map(function (item) { return String(item.variantId); });
    try {
      window.klaviyo.track('Added product to wishlist', {
        ProductId: record.productId,
        VariantId: record.variantId,
        ItemId: record.productId,
        LatestWishlistItems: latest,
        WishlistVariantIds: flat
      });
    } catch (e) {}
  }

  /* One delegated listener for the whole page. Not one per card. */
  document.addEventListener('click', function (event) {
    var el = event.target.closest ? event.target.closest(SELECTOR) : null;
    if (!el) { return; }
    event.preventDefault();

    var record = recordFrom(el);
    if (!record.productId) { return; }

    if (setAside.has(record.productId)) {
      setAside.remove(record.productId);
    } else {
      setAside.add(record);
      tellKlaviyo(record);
    }
  });

  /* The card's press feedback dims the photo (#5E4D44 multiply veil, mg-card-press-fix.css). It is
     armed two ways — the CSS :active path, and a .mg-press class added by Login.js on pointerdown —
     and BOTH exempt only Swish's .wk-button. So a tap on our diamond dimmed the whole card as if it
     had been clicked through to the PDP (Will, 1 Sep, on mobile).

     mg-setaside.css handles the :active path. This handles .mg-press, which is the one that fires on
     touch: .mg-press is added on a timer AFTER pointerdown and survives pointerup, so :has(:active)
     can never suppress it and CSS alone could not fix this. We mark the card for exactly as long as
     a press that STARTED on the diamond lasts, and mg-setaside.css reads that class.

     Capture phase, so it runs before Login.js's own listener. It never calls preventDefault or
     stopPropagation: the card's link, the save click and every other listener behave as before. */
  document.addEventListener('pointerdown', function (event) {
    var el = event.target.closest ? event.target.closest(SELECTOR) : null;
    if (!el) { return; }
    var card = el.closest('.product-wrap');
    if (!card) { return; }

    card.classList.add('mg-setaside-pressing');
    card.classList.remove('mg-press');

    var release = function () {
      card.classList.remove('mg-setaside-pressing');
      card.classList.remove('mg-press');
      document.removeEventListener('pointerup', release, true);
      document.removeEventListener('pointercancel', release, true);
    };
    document.addEventListener('pointerup', release, true);
    document.addEventListener('pointercancel', release, true);
  }, true);

  /* ---------------- The Set Aside page ---------------- */

  /* The page ships as a frame with an empty grid. The list lives in the browser,
     so the server cannot render the cards — each one is fetched from
     sections/mg-setaside-card.liquid through the Section Rendering API.
     Build spec §11.7. Verified 1 Sep (C38) that cards inserted this way DO bind
     to the theme's cart and that <variant-selection> upgrades itself.

     ⚠️ The §5 performance argument does not apply to this page and is not
     claimed for it. Swish works the same way today. Typical list is 2–8 items
     on one low-traffic page. */
  function sharedHandles() {
    var m = window.location.search.match(/[?&]list=([^&]*)/);
    if (!m) { return null; }
    var raw = decodeURIComponent(m[1] || '').split(',');
    var out = [];
    for (var i = 0; i < raw.length; i++) {
      var h = raw[i].trim();
      /* Handles only — anything else is somebody testing the query string. */
      if (/^[a-z0-9-]{1,120}$/.test(h) && out.indexOf(h) === -1) { out.push(h); }
    }
    return out.length ? out.slice(0, 40) : null;
  }

  function renderPage() {
    var page = document.querySelector('[data-mg-setaside-page]');
    if (!page) { return; }

    var grid = page.querySelector('[data-mg-setaside-grid]');
    var gridWrap = page.querySelector('[data-mg-setaside-grid-wrap]');
    var empty = page.querySelector('[data-mg-setaside-empty]');
    var errorEl = page.querySelector('[data-mg-setaside-error]');
    /* A shared list (?list=handle,handle) renders INSTEAD of the browser's own,
       read-only: no ✕, because it is not yours to edit. v1 sharing is
       link-encoded — there is no server until January (§2). */
    var shared = sharedHandles();
    var items = shared ? shared.map(function (h) { return { handle: h, productId: 0 }; })
                       : read().items;
    if (shared) {
      page.setAttribute('data-mg-setaside-shared', '');
      /* Copy, Will 4 Sep: a recipient must not read "Items you've Set Aside"
         about somebody else's list. Written here and not in Liquid because
         Liquid cannot see the query string — ?list= is visible only to JS.
         ⚠️ The count <sup> is saved and re-attached: textContent would drop it,
         and the shared count is written into that same node further down. */
      var heading = page.querySelector('h1');
      if (heading) {
        var keepSup = heading.querySelector('[data-mg-setaside-count-sup]');
        heading.textContent = 'A shared Set Aside';
        if (keepSup) {
          heading.appendChild(document.createTextNode(' '));
          heading.appendChild(keepSup);
        }
      }
    }

    if (!items.length) {
      if (grid) { grid.innerHTML = ''; }
      if (gridWrap) { gridWrap.hidden = true; }
      if (errorEl) { errorEl.hidden = true; }
      if (empty) { empty.hidden = false; }
      return;
    }
    if (empty) { empty.hidden = true; }

    var results = new Array(items.length);
    var missing = [];
    var pending = items.length;

    for (var i = 0; i < items.length; i++) {
      (function (item, index) {
        var url = '/products/' + encodeURIComponent(item.handle) + '?section_id=mg-setaside-card';
        window.fetch(url, { credentials: 'same-origin' })
          .then(function (res) {
            /* A 404 means the product is gone from Shopify for good, so drop it
               from the list. Any OTHER failure is probably the network, and must
               NOT delete somebody's saved item — that card is just skipped this
               time round. Build spec §9. */
            if (res.status === 404) { missing.push(item.productId); return null; }
            if (!res.ok) { return null; }
            return res.text();
          })
          .catch(function () { return null; })
          .then(function (html) {
            results[index] = html || null;
            pending = pending - 1;
            if (pending === 0) { paintCards(); }
          });
      })(items[i], i);
    }

    function paintCards() {
      var frag = document.createDocumentFragment();
      var shown = 0;
      for (var n = 0; n < results.length; n++) {
        if (!results[n]) { continue; }
        var holder = document.createElement('div');
        holder.innerHTML = results[n];
        var card = holder.querySelector('[data-mg-setaside-card]');
        if (!card) {
          /* ⚠️ C72, 5 Sep. AN ARCHIVED PRODUCT DOES NOT 404. The section
             endpoint answers 200 with nothing in it, so the 404 branch above
             never fires and the item sat in localStorage for good. The symptom
             was a header count that disagreed with the page — measured 2 stored,
             1 card rendered, header "2" — and it worsens as products retire.
             Rendering nothing is as final as a 404, so treat it the same.
             ⚠️ Never on a shared list: those items are not ours to prune, and
             they carry productId 0 anyway. */
          if (!shared && items[n] && items[n].productId) { missing.push(items[n].productId); }
          continue;
        }
        frag.appendChild(card);
        shown = shown + 1;
      }

      if (grid) {
        grid.innerHTML = '';
        grid.appendChild(frag);
      }
      if (gridWrap) { gridWrap.hidden = shown === 0; }
      /* On a shared list the superscript must count what is ON SCREEN, not the
         viewer's own list — otherwise three shared cards sit under a "6".
         The title itself is rewritten to "A shared Set Aside" in renderPage. */
      if (shared) {
        var sup = document.querySelector('[data-mg-setaside-count-sup]');
        if (sup) { sup.textContent = shown ? String(shown) : ''; }
      }
      wireCards(grid);
      syncControls();
      /* Only shout if NOTHING loaded. One card missing is a deleted product or a
         dropped request; none loading means something is actually wrong. */
      if (errorEl) { errorEl.hidden = shown !== 0; }

      /* Prune deleted products once, after the pass. commit() announces, which
         repaints the counts — it does NOT re-enter renderPage, so there is no
         refetch loop. */
      if (missing.length) {
        var data = read();
        data.items = data.items.filter(function (it) {
          return missing.indexOf(it.productId) === -1;
        });
        commit(data);
        if (!data.items.length) {
          if (gridWrap) { gridWrap.hidden = true; }
          if (errorEl) { errorEl.hidden = true; }
          if (empty) { empty.hidden = false; }
        }
      }
    }
  }

  /* ---------------- Making an injected card's size selector work ----------

     ⚠️ INLINE <script> TAGS SET VIA innerHTML NEVER RUN. The product form the
     card reuses ships three kinds of inline script, and all of them were dead
     on this page — which is exactly why the size dropdown did nothing (Will,
     2 Sep). Diagnosed rather than guessed:

     ⋄ `script.id-script`, one per swatch option. On a normal page load these
       give each radio a unique `id` and its <label> a matching `for`. Without
       them the labels point at nothing, so clicking a size does nothing at all.
     ⋄ a jQuery block that opens and closes the dropdown, bound with
       DOCUMENT-WIDE selectors (`$(".selected_variant_option")`).
     ⋄ one short self-locating script, which needs to be the last <script> in
       the document to find itself.

     ⚠️ RE-INJECTING THEM AS REAL <script> NODES WAS TRIED AND IS WRONG. The
     id-scripts locate themselves by scanning the document for the first
     UNPROCESSED one, so with several cards on the page they cross-contaminate:
     measured ids from the wrong product, and three options sharing one id.
     The jQuery block has the opposite problem — run once per card it binds N
     click handlers to every dropdown, so a click toggles N times.

     SO: the ids are written HERE, deterministically and per card, and the
     theme's id-scripts are removed so they cannot half-run. The jQuery block
     is executed exactly ONCE, after every card is in the DOM, which is all it
     needs — its selectors are document-wide and its handler works off
     `$(this)` / `.closest()`.
     ⭐ The radio `name` is left alone (`option-0`). It looks like a collision
     across cards and is not: each card has its own <form>, and a radio group is
     scoped to its form. */
  var toggleScriptRun = false;

  function wireCards(grid) {
    if (!grid) { return; }

    var cards = grid.querySelectorAll('[data-mg-setaside-card]');
    var toggleSrc = null;

    for (var c = 0; c < cards.length; c++) {
      var card = cards[c];
      var pid = card.getAttribute('data-product-id') || String(c);

      var opts = card.querySelectorAll('.swatch__options .swatch__option');
      for (var o = 0; o < opts.length; o++) {
        var input = opts[o].querySelector('input');
        var label = opts[o].querySelector('label');
        if (!input || !label) { continue; }
        var id = 'mg-sa-' + pid + '-' + o;
        input.id = id;
        label.setAttribute('for', id);
      }

      /* ---- SOLD OUT ------------------------------------------------
         ⚠️ CORRECTION, 3 Sep. This first shipped as "NOTIFY ME", on my claim
         that the theme's Klaviyo back-in-stock trigger worked here. IT DOES
         NOT. I had matched on `input[type=email]` becoming visible after the
         click — which was the FOOTER NEWSLETTER form, present on every page
         before the click ever happened. No Klaviyo form opened, then or now.
         ⭐ The rule that would have caught it: a positive signal is only
         evidence if it could have been negative.

         WHY IT CANNOT WORK AS-IS. MG's own inline fix from 2 Jul says Klaviyo
         BIS "rewrites the trigger's whole style attribute when swapping it in"
         — the BIS script SWAPS THE NODE IN at page load, and these cards are
         injected long after. Third instance on this page of something that
         runs once at load and never sees us (see the inline product scripts).

         WILL'S CALL, 3 Sep: replace it with a plain SOLD OUT panel rather than
         re-binding Klaviyo. It is honest, it cannot mislead somebody into
         thinking they have been notified, and it matches the SOLD OUT sticker
         already on the image. Revisit BIS after 24 Oct, when product__form is
         open anyway.

         ⚠️ REPLACED, not restyled. Left as a <button> it keeps three faults at
         once: it is a direct child of `.purchase-details` (not of
         `.purchase-details__buttons`) so it sits 7px high; it has no 1px
         border so it measures 45px against Add to Cart's 44; and the theme's
         `.button--add-to-cart:hover { background: #F4F3F0 !important }`
         inverts it to an off-white box on an off-white page — Will's "it
         disappears on hover". A plain div inherits none of that.
         ⭐ Styled inline rather than in mg-setaside.css, following the same
         house pattern as `__mgCounts` in mg-grid-reveal.js: an element created
         and owned by JS carries its own styles. It also keeps this fix out of
         a stylesheet that has outgrown the upload method (C57).
         ⚠️ The 7px margin is the house value — the same gap MG's 2 Jul script
         enforces on the product page so this control lines up with Add to Cart. */
      var bis = card.querySelector('.klaviyo-bis-trigger');
      if (bis && bis.parentNode) {
        var out = document.createElement('div');
        out.className = 'mg-setaside-soldout';
        out.textContent = 'Sold out';
        out.style.cssText = [
          'display:flex',
          'align-items:center',
          'justify-content:center',
          'width:100%',
          'height:44px',
          'margin-top:7px',
          'box-sizing:border-box',
          'border:1px solid #5E4D44',
          'background:#F4F3F0',
          'color:#5E4D44',
          'font-family:"Neue Haas Grotesk Text W01","Helvetica Neue",Arial,sans-serif',
          'font-size:14px',
          'letter-spacing:.5px',
          'line-height:1',
          'text-transform:uppercase',
          'cursor:default',
          'user-select:none'
        ].join(';');
        bis.parentNode.replaceChild(out, bis);
      }

      var dead = card.querySelectorAll('script.id-script');
      for (var d = 0; d < dead.length; d++) {
        if (dead[d].parentNode) { dead[d].parentNode.removeChild(dead[d]); }
      }

      if (!toggleSrc) {
        var scripts = card.querySelectorAll('script:not([src])');
        for (var t = 0; t < scripts.length; t++) {
          if (scripts[t].textContent.indexOf('selected_variant_option') > -1) {
            toggleSrc = scripts[t].textContent;
            break;
          }
        }
      }
    }

    /* Once per page. A second run would double every click handler. */
    if (toggleSrc && !toggleScriptRun) {
      toggleScriptRun = true;
      try {
        var node = document.createElement('script');
        node.textContent = toggleSrc;
        document.body.appendChild(node);
        if (node.parentNode) { node.parentNode.removeChild(node); }
      } catch (e) {}
    }
  }

  /* ---------------- Add all to cart · Share your Set Aside --------------

     Both mirror the live page's behaviour exactly (Will, 2 Sep):
       Add all  →  "Adding…"  →  "Added to cart", and "Added to cart" HOLDS
                   until the list itself changes.
       Share    →  flashes "Set Aside link copied" for 3 seconds, off the REAL
                   clipboard write — a native mobile share sheet copies nothing,
                   so it correctly shows no message.

     ⚠️ ADD-ALL GOES THROUGH THE THEME'S OWN BUTTONS, one card at a time, rather
     than POSTing to /cart/add.js. Measured 2 Sep: a direct POST does add the
     items, but the header count and the cart drawer both stay stale — the
     drawer's own refresh is inside a webpack bundle with no public handle, and
     opening it does NOT resync. Clicking the card's real button is the only
     path that leaves every part of the theme correct. It is also the path C38
     already proved binds. The cost is that the drawer opens, which is what a
     normal add does anyway.

     ⚠️ THE ADD LABEL IS "Add all items to cart" (Will, 3 Sep). It renders in
     caps because mg-setaside-page.liquid sets text-transform on the control —
     the strings stay sentence case here so all three states pick the caps up
     together and nothing has to be retyped in two places. */
  var LABELS = {
    add:   { def: 'Add all items to cart', busy: 'Adding…', done: 'Added to cart' },
    share: { def: 'Share your Set Aside', done: 'Set Aside link copied' }
  };
  var ctlState = { add: 'def', share: 'def' };
  var shareTimer = null;

  function ctlBtn(which) {
    return document.querySelector('[data-mg-setaside-' + which + ']');
  }

  function paintControls() {
    ['add', 'share'].forEach(function (which) {
      var btn = ctlBtn(which);
      if (!btn) { return; }
      var want = LABELS[which][ctlState[which]] || LABELS[which].def;
      var txt = btn.querySelector('.mg-setaside-ctl__text');
      if (txt && txt.textContent !== want) { txt.textContent = want; }
      btn.setAttribute('aria-label', want);
    });
  }

  function setCtl(which, state) {
    if (ctlState[which] === state) { return; }
    ctlState[which] = state;
    paintControls();
  }

  /* Hidden with the grid, so an empty list never offers "Add all to cart". */
  function syncControls() {
    var wrap = document.querySelector('[data-mg-setaside-controls]');
    if (!wrap) { return; }
    wrap.hidden = setAside.count() === 0;
    paintControls();
  }

  function cartCount() {
    var el = document.querySelector('[data-bind="itemCount"]');
    return el ? el.textContent.trim() : null;
  }

  function addAll() {
    var grid = document.querySelector('[data-mg-setaside-grid]');
    if (!grid) { return; }
    var cards = grid.querySelectorAll('[data-mg-setaside-card]');
    var btn = ctlBtn('add');
    var finished = false;

    if (btn) { btn.disabled = true; }
    setCtl('add', 'busy');

    /* ⚠️ A HARD CEILING, because the first build of this DID hang. Measured
       2 Sep: it added three of six and then sat on "Adding…" for good. Rather
       than chase the one card that stopped it, the run is now built so that
       NOTHING can leave the button stuck — every step is timeout-driven, the
       click is wrapped, and this guard finishes the run whatever happens. */
    var guard = setTimeout(finish, 60000);

    function finish() {
      if (finished) { return; }
      finished = true;
      clearTimeout(guard);
      if (btn) { btn.disabled = false; }
      setCtl('add', 'done');
    }

    var i = 0;
    function step() {
      if (finished) { return; }
      if (i >= cards.length) { finish(); return; }

      var card = cards[i];
      i = i + 1;

      var submit = card.querySelector('.mg-setaside-card__actions button[type="submit"]');
      if (!submit || submit.disabled) { setTimeout(step, 60); return; }

      var before = cartCount();
      try { submit.click(); } catch (e) {}

      /* Move on when the theme reports the add, or after 5s either way — a
         sold-out line, a stock clamp or a failed request must not stop the
         cards behind it. */
      var waited = 0;
      var poll = setInterval(function () {
        waited = waited + 150;
        if (cartCount() !== before || waited >= 5000) {
          clearInterval(poll);
          setTimeout(step, 150);
        }
      }, 150);
    }

    step();
  }

  /* v1 sharing is link-encoded — there is no server until January (§2). The
     link carries the product handles, and a page opened with ?list= renders
     those instead of the browser's own list. */
  function shareUrl() {
    var handles = setAside.get().map(function (item) { return item.handle; })
      .filter(function (h) { return !!h; });
    return window.location.origin + window.location.pathname +
      '?list=' + encodeURIComponent(handles.join(','));
  }

  function flashShare() {
    setCtl('share', 'done');
    clearTimeout(shareTimer);
    shareTimer = setTimeout(function () { setCtl('share', 'def'); }, 3000);
  }

  function doShare() {
    var url = shareUrl();
    /* ⚠️ THE SHARE SHEET IS FOR TOUCH ONLY. Desktop Chrome exposes
       `navigator.share` too, so an unguarded check sent a desktop click to the
       OS share sheet and never copied anything — measured 2 Sep. The live page
       copies on desktop, so the sheet is gated on a coarse pointer. A share
       sheet copies nothing, which is why it correctly shows no message. */
    if (navigator.share && window.matchMedia &&
        window.matchMedia('(pointer: coarse)').matches) {
      navigator.share({ title: "Items I've Set Aside", url: url }).catch(function () {});
      return;
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(flashShare).catch(function () {});
      return;
    }
    try {
      var ta = document.createElement('textarea');
      ta.value = url;
      ta.setAttribute('readonly', '');
      ta.style.position = 'absolute';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
      flashShare();
    } catch (e) {}
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest) { return; }
    if (event.target.closest('[data-mg-setaside-add]')) { event.preventDefault(); addAll(); return; }
    if (event.target.closest('[data-mg-setaside-share]')) { event.preventDefault(); doShare(); }
  });

  /* "Added to cart" holds until the list itself changes — Will's call on the
     live page, kept here. */
  setAside.subscribe(function () {
    if (ctlState.add === 'done') { setCtl('add', 'def'); }
    syncControls();
  });

  /* The ✕ on a card. Delegated, like the diamond. Removes the item and takes the
     card out directly rather than re-fetching the whole list. */
  document.addEventListener('click', function (event) {
    var el = event.target.closest ? event.target.closest('[data-mg-setaside-remove]') : null;
    if (!el) { return; }
    event.preventDefault();

    var productId = parseInt(el.getAttribute('data-product-id'), 10);
    if (!productId) { return; }

    setAside.remove(productId);

    var card = el.closest('[data-mg-setaside-card]');
    if (card && card.parentNode) { card.parentNode.removeChild(card); }

    var page = document.querySelector('[data-mg-setaside-page]');
    if (page && setAside.count() === 0) {
      var gw = page.querySelector('[data-mg-setaside-grid-wrap]');
      var em = page.querySelector('[data-mg-setaside-empty]');
      if (gw) { gw.hidden = true; }
      if (em) { em.hidden = false; }
    }
  });

  /* A save in one tab updates the count in the other. */
  window.addEventListener('storage', function (event) {
    if (event.key !== KEY) { return; }
    cache = null;
    announce();
    renderPage();
  });

  setAside.subscribe(paint);

  function start() {
    paint();
    renderPage();
    syncControls();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
